console.log('🔧 main.tsx executing...');

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import "./styles/main.scss";
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';
import global_en from './translations/en/global.json';
import global_es from './translations/es/global.json';
import { I18nProvider } from './features/i18n/I18nProvider';
import { logVersionInfo } from './utils/version';
import { logDebugInfo, checkEnvironmentVariables } from './utils/debug';

// Log version information
logVersionInfo();

// Log debug information
logDebugInfo();
checkEnvironmentVariables();

// Import weather development utilities
if (import.meta.env.DEV) {
  import('./api/weather/configValidator').then(({ validateWeatherConfig }) => {
    validateWeatherConfig();
    console.log('🌤️ Weather development utilities loaded');
  }).catch(error => {
    console.warn('⚠️ Could not load weather dev utilities:', error);
  });
}

console.log('✅ All imports loaded');

try {
  i18next.init({
    interpolation: { escapeValue: false },
    lng: 'es',
    resources: {
      en: { global: global_en },
      es: { global: global_es },
    },
  });
  console.log('✅ i18next initialized');
} catch (error) {
  console.error('❌ i18next failed:', error);
}

const rootElement = document.getElementById('root');
console.log('🎯 Root element:', !!rootElement);

if (!rootElement) {
  console.error('❌ No root element!');
  document.body.innerHTML = '<div style="padding: 20px; color: red;">ERROR: No root element found</div>';
} else {
  try {
    console.log('🚀 Creating root...');
    const root = createRoot(rootElement);
    
    console.log('🎨 Rendering...');
    root.render(
      <StrictMode>
        <I18nextProvider i18n={i18next}>
          <I18nProvider >
            <App />
          </I18nProvider >
        </I18nextProvider>
      </StrictMode>,
    );
    console.log('✅ Rendered successfully');
  } catch (error) {
    console.error('❌ Render failed:', error);
    rootElement.innerHTML = `<div style="padding: 20px; color: red;">Render Error: ${error instanceof Error ? error.message : String(error)}</div>`;
  }
}
